import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import {useEffect, useState} from 'react'
// import Link from 'next/link'

import type { Item, PreparationForm, Draft, OpinionDocument, MainProposal, EnvironmentalConservation, EnvironmentalImpactDocument } from '@/modules/project'

import Dayjs from '@/components/dayjs'
import { Type, State, Step } from '@/components/typeConverter'
import CircleIcon from '@/components/svgIcons/Circle'

import ProjectStatusTable from './ProjectStatusTable';
import style from './item.module.css'

import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Tab5 from './Tab5'
import Tab6 from './Tab6'

interface IProps {
  item: Item
  preparationFormItem: PreparationForm
  projectDraftItem: Draft
  opinionDocumentItem: OpinionDocument
  mainProposalItem: MainProposal[]
  environmentConservationItem: EnvironmentalConservation[]
  environmentalImpactItem: EnvironmentalImpactDocument
}


const Component: NextPage<IProps> = (
    {
      item,
      preparationFormItem ,
      projectDraftItem,
      opinionDocumentItem,
      mainProposalItem,
      environmentConservationItem,
      environmentalImpactItem
    }
) => {
  const Router = useRouter();

  const [activeTab, setActiveTab] = useState('tab1');
  const [tabItems, setTabItems] = useState<{id: string, title: string}[]>([]);


  useEffect(() => {

    if (mainProposalItem && environmentConservationItem.length > 0) {
      setTabItems([
        { id: "tab1", title: "평가준비서" },
        { id: "tab2", title: "초안" },
        { id: "tab3", title: "주민의견수렴결과" },
        { id: "tab4", title: "본안" },
        { id: "tab5", title: "환경보전방안서" },
        { id: "tab6", title: "사후환경영향조사" }
      ]);
    } else if (mainProposalItem && mainProposalItem.length > 0) {
      setTabItems([
        { id: "tab1", title: "평가준비서" },
        { id: "tab2", title: "초안" },
        { id: "tab3", title: "주민의견수렴결과" },
        { id: "tab4", title: "본안" },
        { id: "tab5", title: "환경보전방안서" }
      ]);
    } else if (opinionDocumentItem != undefined){
      setTabItems([
        { id: "tab1", title: "평가준비서" },
        { id: "tab2", title: "초안" },
        { id: "tab3", title: "주민의견수렴결과" },
        { id: "tab4", title: "본안" }
      ]);
    } else if (projectDraftItem != undefined) {
      setTabItems(
          [
            { id: "tab1", title: "평가준비서" },
            { id: "tab2", title: "초안" },
            { id: "tab3", title: "주민의견수렴결과" }
          ]
      );
    } else if (preparationFormItem != undefined) {
      setTabItems([
        { id: "tab1", title: "평가준비서" },
        { id: "tab2", title: "초안" }
      ]);
    } else {
      setTabItems([
        { id: "tab1", title: "평가준비서" }
      ]);
    }
  }, []);

  return (
    <div className='flex flex-col items-center'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center my-16'>
        <div className='w-full'>
          <h1 className={`${style.h1} pb-6 border-b-2 border-b-[#111111]`}>경기도평가정보조회</h1>

          <section>
            <h2 className={style.h2}>
              <CircleIcon /> 사업기본정보
            </h2>
            <div>
              <table className={style.baseInfoTable}>
                <colgroup>
                  <col width={200}/>
                  <col width={400}/>
                  <col width={200}/>
                  <col width={400}/>
                </colgroup>
                <tbody>
                  <tr>
                    <th>사업번호</th>
                    <td>{item.id}</td>
                    <th>진행단계/진행상태</th>
                    <td>
                      <Step>{item.step}</Step> / <State>{item.state}</State>
                    </td>
                  </tr>
                  <tr>
                    <th>사업분야</th>
                    <td><Type>{item.type}</Type></td>
                    <th>사업가</th>
                    <td>{item.businessName}</td>
                  </tr>
                  <tr>
                    <th>사업(평가서명)</th>
                    <td>{item.name}</td>
                    <th>사업기간</th>
                    <td><Dayjs format="dateDot">{item.start}</Dayjs> ~ <Dayjs format="dateDot">{item.end}</Dayjs></td>
                  </tr>
                  <tr>
                    <th>주관기관</th>
                    <td>{item.supervisionInstitution}</td>
                    <th>협의근거</th>
                    <td>{item.basisForConsultation}</td>
                  </tr>
                  <tr>
                    <th>승인기관</th>
                    <td>{item.approvalInstitution}</td>
                    <th>협의기관</th>
                    <td>{item.consultationInstitution}</td>
                  </tr>
                  <tr>
                    <th>사업지역위치</th>
                    <td>{item.place}</td>
                    <th>업무담당자(협의)</th>
                    <td>{item.manager}</td>
                  </tr>
                  <tr>
                    <th>환경영향평가업체</th>
                    <td colSpan={3}>{item.environmentalImpactAssessmentCompany || '-'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 협의진행 상황 */}
          <ProjectStatusTable item={item} />

          <section className='mt-24'>
            <div className='flex h-[70px]'>
              {tabItems.map(item => (
                <div
                  key={item.id}
                  className={`
                    ${item.id === activeTab ? 'bg-gg-blue !text-white' : 'bg-[#F7F7F7] cursor-pointer hover:bg-blue-50'}
                    flex basis-1/6 items-center justify-center
                    text-[18px] text-[#111111] font-medium
                    border border-[#DDDDDD] border-r-0 last:border-r last:border-r[#DDDDDD]
                  `}
                  onClick={() => setActiveTab(item.id)}
                >
                  {item.title}
                </div>
              ))}
            </div>
          </section>

          <Tab1 className={activeTab === 'tab1' ? '' : 'hidden'} item={preparationFormItem}/>
          <Tab2 className={activeTab === 'tab2' ? '' : 'hidden'} item={projectDraftItem}/>
          <Tab3 className={activeTab === 'tab3' ? '' : 'hidden'} item={opinionDocumentItem}/>
          <Tab4 className={activeTab === 'tab4' ? '' : 'hidden'} item={mainProposalItem}/>
          <Tab5 className={activeTab === 'tab5' ? '' : 'hidden'} items={environmentConservationItem}/>
          <Tab6 className={activeTab === 'tab6' ? '' : 'hidden'} item={environmentalImpactItem}/>

        </div>
      </div>
    </div>
  )
}

export default Component
